import {
  BookOpenIcon,
  ChartPieIcon,
  CurrencyDollarIcon,
  ScaleIcon,
  UsersIcon,
  BuildingOffice2Icon,
  CreditCardIcon
} from '@heroicons/react/24/outline';
import config from '../../config';

export const ROLES = {
  ADMIN: 'ADMIN',
  RECEPCIONIST: 'RECEPCIONIST'
};

export const NAVIGATION = [
  { name: 'Reportes', href: '/reports', icon: ChartPieIcon, roles: [ROLES.ADMIN], externalLink: false },
  { name: 'Ingresos/Egresos', href: '/ledger', icon: CurrencyDollarIcon, roles: [ROLES.ADMIN, ROLES.RECEPCIONIST], externalLink: false },
  { name: 'Detalle de Resultados', href: '/income_statement/details', icon: BookOpenIcon, roles: [ROLES.ADMIN], externalLink: false },
  { name: 'Estado de Resultados', href: '/income_statement/general', icon: ScaleIcon, roles: [ROLES.ADMIN], externalLink: false },
  { name: 'Sucursales', href: '/branches', icon: BuildingOffice2Icon, roles: [ROLES.ADMIN], externalLink: false },
  { name: 'Usuarios', href: '/users', icon: UsersIcon, roles: [ROLES.ADMIN], externalLink: false },
  { name: 'Suscripción', href: `${config.roenBackendURL}/v1/billing/manage`, icon: CreditCardIcon, roles: [ROLES.ADMIN], externalLink: true },
];
